export default {
    data: {
        address: {
            address_1: null,
            address_2: null,
            city: null,
            postcode: null,
            display_name: null,
        },
        country_code: 'GBR',
        id: null,
        position: {
            lat: null,
            lng: null,
        },
        dynamic_pricing: 1,
        streetview: {
            latitude: null,
            longitude: null,
            heading: null,
            pitch: null,
        },
        additional_information: null,
        additional_post_booking_info: null,
        amount_of_notice_required: null,
        listing_progress: [],
        features: [],
        space_size: null,
        max_access_height: null,
        space_type: 'parking',
        available_spaces: 1,
        available_from: null,
        access_pin: null,
        access_method: null,
        allocated: null,
        allocated_info: null,
        permit: null,
        price_hourly: null,
        price_daily: null,
        price_monthly: null,
        price_monthly_mon_fri: null,
        lt_plans: [],
        upper_period_limit: null,
        overnight_booking: true,
        options: {
            nearby_locations: [],
        },
        rental_types: {
            daily: true,
            monthly: true,
        },
        enabled: false,
        listing_completed_at: null,
        space_payout_fee_percentage: 0.00,
    },
};
